import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";

interface IProps {
  setIsShowLogout: () => void;
}

const Header: React.FC<IProps> = ({ setIsShowLogout }) => {
  const [isShowMobile, setShowMobile] = useState(false);

  let userInfoString = localStorage.getItem("user_info");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
  
  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setUserProfile(data);
        localStorage.setItem("user_info", JSON.stringify({
          coins: data.coins,
          role: data.role,
          userName: data.username,
        }));
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);


  return (
    <div className="w-full h-[80px]">
      <style>{`
        .menu-lobby {
          background-image: url('/assets/bg-header.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
        .header-nav {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          position: relative;
        }
        .desktop-logo-header {
          display: none;
        }
        @media (min-width: 769px) {
          .desktop-logo-header {
            display: block !important;
            position: absolute !important;
            left: 20px !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
            z-index: 100 !important;
            max-width: 200px !important;
            height: auto !important;
            margin: 0 !important;
            padding: 0 !important;
          }
        }
        /* Facebook icon - same position as login page */
        .facebook-link-header {
          position: fixed;
          right: 15px;
          bottom: calc(30% + 100px);
          z-index: 10;
          display: block;
        }
        .facebook-icon-header {
          width: 130px;
          height: 130px;
          cursor: pointer;
          transition: transform 0.3s ease;
          display: block;
        }
        .facebook-link-header:hover .facebook-icon-header {
          transform: scale(1.1);
        }
        /* Telegram icon - same position as login page */
        .telegram-link-header {
          position: fixed;
          right: 30px;
          bottom: 30%;
          z-index: 10;
          display: block;
        }
        .telegram-icon-header {
          width: 100px;
          height: 100px;
          cursor: pointer;
          transition: transform 0.3s ease;
          display: block;
        }
        .telegram-link-header:hover .telegram-icon-header {
          transform: scale(1.1);
        }
        @media (max-width: 768px) {
          .menu-lobby {
            background-image: url('/assets/bg-header-mb.png');
          }
          .mobile-logo-header {
            display: block !important;
          }
          .header-nav {
            justify-content: space-between;
          }
          /* Mobile responsive - adjusted higher position */
          .facebook-link-header {
            right: 0px;
            top: 20%;
          }
          .facebook-icon-header {
            width: 80px;
            height: 80px;
          }
          .telegram-link-header {
            right: 10px;
            top: calc(21% + 70px);
          }
          .telegram-icon-header {
            width: 60px;
            height: 60px;
          }
        }
        .mobile-logo-header {
          display: none;
        }
      `}</style>
      {/* Facebook Icon - Fixed position like login page */}
      <a 
        href="#" 
        className="facebook-link-header"
      >
        <img 
          src="/assets/fb.png" 
          alt="Facebook"
          className="facebook-icon-header"
        />
      </a>

      {/* Telegram Icon - Fixed position like login page */}
      <a 
        href="https://t.me/TONTON2026VIP" 
        target="_blank" 
        rel="noopener noreferrer"
        className="telegram-link-header"
      >
        <img 
          src="/assets/tele.png" 
          alt="Telegram"
          className="telegram-icon-header"
        />
      </a>

      <header className="menu-lobby py-3">
        <nav className="navbar navbar-expand-lg navbar-dark header-nav">
          {/* Mobile Logo */}
          <img 
            src="/assets/logo-v1e-mb.png" 
            alt="Logo" 
            className="mobile-logo-header"
            style={{ maxWidth: '190px', height: 'auto' }}
          />
          {/* Desktop Logo */}
          <img 
            src="/assets/logo-v1e-mb.png" 
            alt="Logo" 
            className="desktop-logo-header"
            style={{ maxWidth: '200px', height: 'auto' }}
          />
          <div className="menu">
            <div
              className={
                isShowMobile
                  ? "menu_wrapper menu_wrapper_active"
                  : "menu_wrapper"
              }
            >
              {/* menu_wrapper_active */}
              <a href="/" className="menu-item btn-home">
                <p>Trang chủ</p>
              </a>
              <div className="menu-item btn-user flex items-center">
                <img
                  src="/assets/user-ico.png"
                  alt="pdjhjf"
                  className="w-[30px] h-[30px]"
                />
                <p>{userInfo?.userName}</p>
              </div>
              <div className="menu-item btn-credit2 btn-redeem flex items-center">
                <img
                  src="/assets/coins.png"
                  alt="pdjhjf"
                  className="w-[30px] h-[30px]"
                />
                <p>{userInfo?.coins}</p>
              </div>

              <div
                className="menu-item btn-logout flex items-center"
                onClick={setIsShowLogout}
              >
                <img
                  src="/assets/logout-ico.png"
                  alt="pdjhjf"
                  className="w-[30px] h-[30px]"
                />
                <p>Đăng xuất</p>
              </div>
            </div>
            {isShowMobile ? (
              <div
                className="menu-icon change"
                onClick={() => setShowMobile(false)}
              >
                <div className="bar1" />
                <div className="bar2" />
                <div className="bar3" />
              </div>
            ) : (
              <div className="menu-icon" onClick={() => setShowMobile(true)}>
                <div className="bar1" />
                <div className="bar2" />
                <div className="bar3" />
              </div>
            )}
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
